import { api } from "@/redux/api";

import {
	GlobalSearchEnrichRequest,
	GlobalSearchEnrichResponse,
	GlobalSearchEnrichResponseSchema,
	GlobalSearchResponse,
	GlobalSearchRequest,
	GlobalSearchResponseSchema,
} from "./search.schema";

export const searchApi = api.injectEndpoints({
	endpoints: (builder) => ({
		globalSearch: builder.query<GlobalSearchResponse, GlobalSearchRequest>({
			query: (body) => ({
				url: "global-search",
				method: "POST",
				body,
				responseSchema: GlobalSearchResponseSchema,
			}),
		}),
		globalSearchSearchEmail: builder.mutation<
			GlobalSearchEnrichResponse,
			GlobalSearchEnrichRequest
		>({
			query: (body) => ({
				url: "global-search/searchForEmail",
				method: "PATCH",
				body,
				responseSchema: GlobalSearchEnrichResponseSchema,
			}),
		}),
		globalSearchSearchPhone: builder.mutation<
			GlobalSearchEnrichResponse,
			GlobalSearchEnrichRequest
		>({
			query: (body) => ({
				url: "global-search/searchForPhone",
				method: "PATCH",
				body,
				responseSchema: GlobalSearchEnrichResponseSchema,
			}),
		}),
	}),
});
export const {
	useLazyGlobalSearchQuery,
	useGlobalSearchQuery,
	useGlobalSearchSearchEmailMutation,
	useGlobalSearchSearchPhoneMutation,
} = searchApi;
